import { ReactElement } from "react";
import { FieldValues, UseFormReturn, useFormContext } from "react-hook-form";

type Props<TFieldValues extends FieldValues> = {
  children: (formMethods: UseFormReturn<TFieldValues>) => ReactElement;
};

const ConnectForm = <TFieldValues extends FieldValues>({ children }: Props<TFieldValues>) => {
  const formMethods = useFormContext<TFieldValues>();

  return children({ ...formMethods });
};

export default ConnectForm;
